<template>
  <div class="page-header">
    <div class="page-title">甘肃省开发道路公布情况</div>
  </div>
  <div class="roads-container">
    <!-- 条件筛选区域 -->
    <div class="filter-container">
      <div class="filter-section">
        <span class="filter-title">城市：</span>
        <div class="city-options">
          <a-checkbox :checked="cityFilter.includes(0)" @change="handleCheckboxChange(0)" class="custom-checkbox">
            <span class="checkbox-label">全部</span>
          </a-checkbox>
          <a-checkbox 
            v-for="city in cities" 
            :key="city.id"
            :checked="cityFilter.includes(city.id)"
            @change="handleCheckboxChange(city.id)"
            class="custom-checkbox"
          >
            <span class="checkbox-label">{{ city.name }}</span>
          </a-checkbox>
        </div>
      </div>
      
      <!-- 新增分类筛选区域 -->
<!--      <div class="filter-section">-->
<!--        <span class="filter-title">分类：</span>-->
<!--        <div class="category-options">-->
<!--          <a-checkbox :checked="categoryFilter.includes('all')" @change="handleCategoryChange('all')" class="custom-checkbox">-->
<!--            <span class="checkbox-label">全部</span>-->
<!--          </a-checkbox>-->
<!--          <a-checkbox -->
<!--            v-for="category in categories" -->
<!--            :key="category.categoryCode"-->
<!--            :checked="categoryFilter.includes(category.categoryCode)"-->
<!--            @change="handleCategoryChange(category.categoryCode)"-->
<!--            class="custom-checkbox"-->
<!--          >-->
<!--            <span class="checkbox-label">{{ category.categoryName }}</span>-->
<!--          </a-checkbox>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <!-- 道路列表区域 -->
    <div class="roads-list-container">
      <div class="region-list">
        <div 
          v-for="region in filteredRegions"
          :key="region.areaId"
          class="region-item"
        >
          <!-- 左侧区域信息 -->
          <div class="region-info">
            <div class="region-name">{{ region.areaName }}</div>
            <div class="region-city">{{ region.cityName }}</div>
            <div class="region-stats">
              <div class="stat-item">
                <span class="stat-label">道路总数</span>
                <span class="stat-value">{{ region.routes.length }}条</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">覆盖里程</span>
                <span class="stat-value">{{ region.mileage }}公里</span>
              </div>
            </div>
          </div>
          
          <!-- 右侧道路列表 -->
          <div class="roads-list">
            <div 
              v-for="route in region.routes"
              :key="route.id"
              class="road-item"
            >
              <div class="road-content">
                <div class="road-name">{{ route.name }}</div>
                <div class="road-details">
                  <div class="road-categories">
                    <span v-for="(categoryCode, index) in route.category" :key="index" class="road-type">
                      {{ getCategoryName(categoryCode) }}
                    </span>
                  </div>
                  <span class="road-distance">
                    总里程：{{ route.distance }} km
                  </span>
                </div>
              </div>
              <div class="road-nav-icon">
                <img src="@/assets/icons/luxian.png" alt="导航" width="32" height="32" @click="handleNavClick(route)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    
    <!-- 地图弹框 -->
    <a-modal v-model:open="mapModalVisible" :title="selectedRoad ? selectedRoad.name : '道路地图'" :width="1100" :footer="null">
      <div id="road-map-container" class="road-map-container"></div>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, reactive } from 'vue'
import Footer from '@/components/GlobalFooter/footer.vue'
import AMapLoader from '@amap/amap-jsapi-loader'
import { categoryList } from '@/api/settings/category'
import { getCityList, getOpenRoads } from '@/api/roads/routes'

// 城市筛选条件
const cityFilter = ref([0]);

// 分类筛选条件
const categoryFilter = ref(['all']);

// 分类列表数据
const categories = ref([]);

// 城市列表数据
const cities = ref([]);

// 地图弹框可见性
const mapModalVisible = ref(false);

// 当前选中的道路
const selectedRoad = ref(null);

// 地图实例引用
const map = ref(null);

// 筛选后的区域列表
const filteredRegions = ref([]);

// 根据分类code获取分类名称
const getCategoryName = (categoryCode) => {
  const category = categories.value.find(cat => cat.categoryCode === categoryCode);
  return category ? category.categoryName : categoryCode;
};

// 城市筛选变化处理
const handleCheckboxChange = (cityValue) => {
  const isChecked = cityFilter.value.includes(cityValue);
  
  if (cityValue === 0) {
    // 处理"全部"选项
    if (isChecked) {
      cityFilter.value = [];
    } else {
      cityFilter.value = [0];
    }
  } else {
    // 处理具体城市选项
    if (isChecked) {
      cityFilter.value = cityFilter.value.filter(city => city !== cityValue);

      if (cityFilter.value.length === 0) {
        cityFilter.value = [0];
      }
    } else {
      cityFilter.value = [...cityFilter.value.filter(city => city !== 0), cityValue];
    }
  }
  
  // 应用筛选
  applyFilter();
};

// 分类筛选变化处理
const handleCategoryChange = (categoryValue) => {
  const isChecked = categoryFilter.value.includes(categoryValue);
  
  if (categoryValue === 'all') {
    // 处理"全部"选项
    if (isChecked) {
      categoryFilter.value = [];
    } else {
      categoryFilter.value = ['all'];
    }
  } else {
    // 处理具体分类选项
    if (isChecked) {
      categoryFilter.value = categoryFilter.value.filter(category => category !== categoryValue);

      if (categoryFilter.value.length === 0) {
        categoryFilter.value = ['all'];
      }
    } else {
      categoryFilter.value = [...categoryFilter.value.filter(category => category !== 'all'), categoryValue];
    }
  }
  
  // 应用筛选
  applyFilter();
};

// 应用筛选条件
const applyFilter = () => {

  let params = {
    cityIds: cityFilter.value,
    categoryCodes: categoryFilter.value
  }
  getOpenRoads(params).then(res => {
    filteredRegions.value = res.data;
  })
};

// 页面挂载时获取数据
onMounted(async () => {
  // 获取分类列表
  categoryList().then((res) => {
    // 根据其他页面的使用方式，分类数据可能是res.data.intelligent_connected_vehicle和res.data.autonomous_vehicle
    if (res.data) {
      // 合并所有分类数据
      const allCategories = [];
      if (res.data.intelligent_connected_vehicle && Array.isArray(res.data.intelligent_connected_vehicle)) {
        allCategories.push(...res.data.intelligent_connected_vehicle);
      }
      if (res.data.autonomous_vehicle && Array.isArray(res.data.autonomous_vehicle)) {
        allCategories.push(...res.data.autonomous_vehicle);
      }
      // 如果直接是数组
      if (Array.isArray(res.data)) {
        allCategories.push(...res.data);
      }
      categories.value = allCategories;
    }
  }).catch(error => {
    console.error('获取分类列表失败:', error);
  });
  
  // 获取城市列表
  getCityList().then((res) => {
    if (res.data && Array.isArray(res.data)) {
      cities.value = res.data;
    }
  }).catch(error => {
    console.error('获取城市列表失败:', error);
  });
  
  applyFilter();
});

// 处理导航图标点击事件
const handleNavClick = (road) => {
  selectedRoad.value = road;
  mapModalVisible.value = true;
  // 延迟初始化地图，确保弹框已经渲染完成
  setTimeout(() => {
    initMap();
  }, 200);
};

// 初始化地图
const initMap = async () => {
  try {
    // 确保地图实例已销毁
    if (map.value) {
      map.value.destroy();
      map.value = null;
    }

    // 加载高德地图API
    const AMap = await AMapLoader.load({
      key: '6588d9e5b6ae0751c799cb4c7b3e30be', // 使用项目中已有的高德地图API Key
      version: '2.0',
      plugins: ['AMap.ToolBar', 'AMap.Scale', 'AMap.Geocoder']
    });

    // 创建地图实例
    map.value = new AMap.Map('road-map-container', {
      zoom: 12,
      mapStyle: 'amap://styles/45311ae996a8bea0da10ad5151f72979', // 使用项目中已有的地图样式
      center: [103.726465, 36.107992] // 默认中心点（兰州）
    });

    // 添加工具条和比例尺
    map.value.addControl(new AMap.ToolBar());
    map.value.addControl(new AMap.Scale());

    // 使用道路数据中的geoJson绘制路线
    let roadPath = [];
    if (selectedRoad.value && selectedRoad.value.geoJson) {
      try {
        // 解析geoJson数据
        const geoJsonData = JSON.parse(selectedRoad.value.geoJson);
        if (geoJsonData.type === 'LineString' && geoJsonData.coordinates) {
          // geoJson的coordinates是[经度, 纬度]格式，直接用于高德地图
          roadPath = geoJsonData.coordinates;
        }
      } catch (e) {
        console.error('解析geoJson数据失败:', e);
      }
    }

    // 绘制路线
    const polyline = new AMap.Polyline({
      path: roadPath,
      strokeColor: '#1677ff',
      strokeWeight: 3,
      strokeOpacity: 0.8
    });

    map.value.add(polyline);

    // 调整地图视野以适应路线
    map.value.setFitView([polyline]);

    // 添加道路名称标记
    if (selectedRoad.value && roadPath.length > 0) {
      const marker = new AMap.Marker({
        position: roadPath[0],
        title: selectedRoad.value.name,
        label: {
          content: selectedRoad.value.name,
          offset: new AMap.Pixel(0, -30)
        }
      });
      map.value.add(marker);
    }

  } catch (error) {
    console.error('地图加载失败:', error);
  }
};

// 销毁地图
const destroyMap = () => {
  if (map.value) {
    map.value.destroy();
    map.value = null;
  }
};

// 在组件卸载时销毁地图
onUnmounted(() => {
  destroyMap();
});
</script>

<style scoped lang="less">
.page-header {
  background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%);
  padding: 30px 20px;
  text-align: center;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  font-family: "Microsoft YaHei", Arial, sans-serif;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.roads-container {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 70px);
  width: 100%;
  background-color: #fff;
}

.filter-container {
  background-color: #fff;
  padding: 20px;
  margin: 20px;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.roads-list-container {
  background-color: #fff;
  margin: 0 20px 20px;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  flex: 1;
}

.filter-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.filter-title {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  margin: 0;
}

.city-options {
  display: flex;
  gap: 32px;
}

.category-options {
  display: flex;
  gap: 32px;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.custom-checkbox .ant-checkbox-input {
  display: none;
}

.custom-checkbox .ant-checkbox {
  width: 18px;
  height: 18px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  transition: all 0.3s;
}

.custom-checkbox .ant-checkbox-checked {
  background-color: #1677ff;
  border-color: #1677ff;
}

.custom-checkbox .ant-checkbox-checked::after {
  content: "✓";
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.checkbox-label {
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.custom-checkbox:hover .ant-checkbox {
  border-color: #1677ff;
}

.reserved-area {
  /* 后续可以添加更多筛选条件样式 */
}

.list-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

/* 分页区域 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

/* 区域列表样式 */
.region-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.region-item {
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: none;
  transition: all 0.3s ease;
  border-bottom: 1px solid #e8e8e8;
}

.region-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* 左侧区域信息样式 */
.region-info {
  width: 200px;
  padding-right: 20px;
  border-right: 2px solid #e8e8e8;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.region-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.region-city {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.road-count {
  font-size: 14px;
  color: #1677ff;
}

.region-stats {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background-color: #f5f7fa;
  border-radius: 6px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stat-label {
  font-size: 13px;
  color: #666;
  font-weight: 500;
}

.stat-value {
  font-size: 15px;
  color: #1677ff;
  font-weight: 600;
}

.region-status {
  margin-top: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.status-badge {
  padding: 4px 12px;
  background-color: #e6f7ff;
  color: #1890ff;
  font-size: 12px;
  border-radius: 12px;
  border: 1px solid #91d5ff;
  font-weight: 500;
}

/* 右侧道路列表样式 */
.roads-list {
  flex: 1;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.road-item {
  background-color: #fff;
  border-radius: 6px;
  padding: 12px;
  border: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}

.road-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.road-nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.road-name {
  font-size: 14px;
}

.road-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.road-categories {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.road-type {
  color: #666;
  background-color: #f0f0f0;
  padding: 2px 8px;
  border-radius: 4px;
}

.road-distance {
  padding: 2px 8px;
  border-radius: 4px;
  color: #666;
}

.road-map-container {
  width: 100%;
  height: 700px;
  border-radius: 4px;
  overflow: hidden;
}
</style>